import { Component } from '@angular/core';
import { IzzyChannelMessageEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Channel Messages') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychannelmessage-form',
    templateUrl: './izzychannelmessage.form.component.html'
})
export class IzzyChannelMessageFormComponent extends BaseFormComponent {
    public record!: IzzyChannelMessageEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'messageMetadata', sectionName: 'Message Metadata', isExpanded: false },
            { sectionKey: 'contentCommunication', sectionName: 'Content & Communication', isExpanded: true },
            { sectionKey: 'relationships', sectionName: 'Relationships', isExpanded: true },
            { sectionKey: 'aIProcessingGeneration', sectionName: 'AI Processing & Generation', isExpanded: true },
            { sectionKey: 'approvalReplyManagement', sectionName: 'Approval & Reply Management', isExpanded: true },
            { sectionKey: 'escalationAssignment', sectionName: 'Escalation & Assignment', isExpanded: true },
            { sectionKey: 'qualityFeedback', sectionName: 'Quality Feedback', isExpanded: true },
            { sectionKey: 'issueTracking', sectionName: 'Issue Tracking', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'channelMessageAttachments', sectionName: 'Channel Message Attachments', isExpanded: false },
            { sectionKey: 'ticketSuggestions', sectionName: 'Ticket Suggestions', isExpanded: false },
            { sectionKey: 'channelMessageNotes', sectionName: 'Channel Message Notes', isExpanded: false },
            { sectionKey: 'channelMessages', sectionName: 'Channel Messages', isExpanded: false }
        ]);
    }
}

